import { checkRpcAccess } from '../services/accessControlService';

const ALLOWED_PROTOCOLS = ['http:', 'https:', 'ws:', 'wss:'];

export async function validateRpcForChain(chainKey, url) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return { ok: false, reason: 'RPC URL 格式錯誤' };
  }

  if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
    return { ok: false, reason: 'RPC 僅支援 http/https/ws/wss' };
  }

  return checkRpcAccess(chainKey, url);
}

export async function validateRpcListForChain(chainKey, listText) {
  const urls = String(listText || '')
    .split(/\n|,/)
    .map((value) => value.trim())
    .filter(Boolean);

  return Promise.all(urls.map(async (rpcUrl) => ({
    url: rpcUrl,
    ...await validateRpcForChain(chainKey, rpcUrl),
  })));
}
